// src/context/SessionContext.js
import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { supabase } from '../supabaseClient';

const SessionContext = createContext();

export function SessionProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getInitialSession = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) throw error;
        
        // Update session state meskipun session null
        if (isMounted) {
          setSession(session); // <-- Ini yang diperbaiki
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          setSession(null);
          setLoading(false);
        }
      }
    };
  
    if (!session) getInitialSession();
  
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, newSession) => {
        if (isMounted) {
          if (JSON.stringify(newSession) !== JSON.stringify(session)) {
            setSession(newSession);
            setLoading(false);
          }
        }
      }
    );

    return () => {
      isMounted = false;
      controller.abort();
      subscription?.unsubscribe();
      // setSession(null);
      // setLoading(true);
    };
  }, [session]);

  // Memoize context value untuk prevent re-render tidak perlu
  const memoizedValue = useMemo(() => ({
    session,
    loading
  }), [session, loading]);

  return (
    <SessionContext.Provider value={memoizedValue}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  return useContext(SessionContext);
}